import { ORDENABLE_PAGE_SIZE } from '@/constants';
import { ListCoursePathFilters } from '@/data/services/coursePathServices';

type CoursePathQueryKeysFiltersParams = {
  courseId?: number;
};

export default function coursePathVersionsFilters({
  courseId,
}: CoursePathQueryKeysFiltersParams): ListCoursePathFilters {
  return {
    courseId: courseId ? [courseId] : undefined,
    ordering: '-version',
    pageSize: ORDENABLE_PAGE_SIZE,
  };
}
